import moment from 'moment';
import { random } from "lodash";
export var scrollToSelect = function scrollToSelect() {
  var $container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.sfx-react-ui-user-profile-overflow';
  var $wrap = document.querySelector($container);
  setTimeout(function () {
    if ($wrap && $wrap.scrollHeight) {
      $wrap.scrollTop = $wrap.scrollHeight + 300;
    }
  }, 0);
};
export var formatFileSize = function formatFileSize(fileSize) {
  if (fileSize < 1024) {
    return "".concat(fileSize, "B");
  } else if (fileSize < 1024 * 1024) {
    var temp = fileSize / 1024;
    temp = Number(temp.toFixed(2));
    return "".concat(temp, "KB");
  } else if (fileSize < 1024 * 1024 * 1024) {
    var _temp = fileSize / (1024 * 1024);

    _temp = Number(_temp.toFixed(2));
    return "".concat(_temp, "MB");
  } else {
    var _temp2 = fileSize / (1024 * 1024 * 1024);

    _temp2 = Number(_temp2.toFixed(2));
    return "".concat(_temp2, "GB");
  }
};
export var breakpoints = {
  lg: {
    winW: 1376,
    wrapW: 1366
  },
  md: {
    winW: 986,
    wrapW: 976
  },
  sm: {
    winW: 676,
    wrapW: 666
  },
  xs: {
    winW: 628,
    wrapW: 340
  }
};
export var truncate = function truncate(text) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var returnString = '';
  var strLen = text ? text.length : 0;

  if (strLen) {
    if (text.length > maxLength) {
      returnString = text.substr(0, maxLength).trim() + "\u2026";
    } else {
      returnString = text;
    }
  }

  return returnString;
};
export var isIncluded = function isIncluded(text, target) {
  var ignoreCase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var formatText = ignoreCase ? text.toLowerCase() : text;
  var formatTarget = ignoreCase ? target.toLowerCase() : target;
  return formatText.includes(formatTarget);
};
export var roundEndTime = function roundEndTime(date) {
  //TODO use the roundUpOnHour function to replace these code
  var newDate = date.clone();
  newDate = newDate.minute() || newDate.second() || newDate.millisecond() ? newDate.add(1, 'hour').startOf('hour') : newDate.startOf('hour');

  if (!newDate.isSame(date, 'day')) {
    newDate.subtract(1, 'day').endOf('day');
  }

  return newDate;
};
export var roundUpOnHour = function roundUpOnHour(date) {
  return date.minute() || date.second() || date.millisecond() ? date.add(1, 'hour').startOf('hour') : date.startOf('hour');
};
export var roundEndTimeToDisplayTime = function roundEndTimeToDisplayTime(date) {
  var newDate = date;

  if (newDate && newDate.isSame(newDate.clone().startOf('day'))) {
    newDate.subtract(1, 'day').endOf('day');
  }

  return newDate;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export var createDateRangeEndOfCurrentDay = function createDateRangeEndOfCurrentDay(range1, range2) {
  return {
    startDate: roundUpOnHour(moment().endOf('day').subtract(range1, range2)),
    endDate: roundEndTime(moment())
  };
};
export var getLastOneDayRange = function getLastOneDayRange() {
  var now = moment();
  return {
    startDate: roundUpOnHour(now.clone().subtract(24, 'hour')),
    endDate: roundEndTime(now.clone())
  };
};
export var getIntNumbersFromString = function getIntNumbersFromString(str) {
  var reg = /\d+/g;
  return str.match(reg);
};
export var makeUuid = function makeUuid() {
  var tick = Date.now() / 1000;
  var max = 1e+9;
  var rand = (1 + random()) * max;
  return tick.toString(16) + rand.toString(16);
};